import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-item-arrow',
  templateUrl: './item-arrow.component.html',
  styleUrls: ['./item-arrow.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.Emulated,
})
export class ItemArrowComponent {}
